// src/pages/BrandsPage.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../config/ApiClient';
import { showError } from '../components/Alert';
import type { StoreDTO } from '../dto/StoreDTO';
import '../styles/BrandsPage.css';

const PLACEHOLDER = '/images/store-placeholder.jpg';

const BrandsPage: React.FC = () => {
  const [stores, setStores] = useState<StoreDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get<StoreDTO[]>('/store/public')
      .then((res) => setStores(res.data))
      .catch((err) => {
        console.error(err);
        showError('Failed to load stores.');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (id: string) => {
    // navigate by ID, not name
    navigate(`/store/${encodeURIComponent(id)}`);
  };

  return (
    <div className="brands-page">
      {/* Chic city header */}
      <div className="city-header">
        <h1 className="city-title">VANCOUVER</h1>
        <div className="city-accent"></div>
      </div>

      {/* Brands container */}
      <div className="brands-container">
        {loading ? (
          <p className="loading">Loading stores…</p>
        ) : stores.length === 0 ? (
          <p className="no-data">No stores available right now.</p>
        ) : (
          <div className="brand-list">
            {stores.map((store) => (
              <div
                key={store.name}
                className="brand-row"
                onClick={() =>
                  navigate(`/store/${encodeURIComponent(store.name)}`)
                }
              >
                <div
                  className="brand-image"
                  style={{
                    backgroundImage: `url(${store.thumbnail || PLACEHOLDER})`,
                  }}
                />
                <div className="brand-info">
                  <h3 className="brand-name">{store.name}</h3>
                  <p className="brand-desc">{store.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandsPage;
